import { useParamsContext } from '../../contexts/ParamsContext';
import RecurringDetail from './RecurringDetail';
import VendasRecorrentes from './RecurringList';
import SaleDetail from './SaleDetail';
import SaleForm from './SaleForm';
import VendasList from './SalesList';
import { Plus } from 'lucide-react';

export default function Vendas() {
    const { action, clear, setParams } = useParamsContext();

    if (action === 'add') return <SaleForm />;
    if (action === 'add-recorrente') return <SaleForm recurring />;
    if (action === 'detail') return <SaleDetail />;
    if (action === 'recorrente') return <RecurringDetail />;

    const showRecurring = action === 'recorrentes';
    const addLabel = showRecurring ? 'Nova recorrência' : 'Nova venda';

    return (
        <div className="sf-page px-2">
            <div className="mb-4 flex items-center gap-2">
                <div className="sf-segmented min-w-0 flex-1 sm:max-w-xs" role="group" aria-label="Seção">
                    <button type="button" aria-pressed={!showRecurring} onClick={() => clear()}>
                        Vendas
                    </button>
                    <button type="button" aria-pressed={showRecurring} onClick={() => setParams({ action: 'recorrentes' })}>
                        Recorrentes
                    </button>
                </div>
                <button
                    type="button"
                    className="btn btn-primary btn-sm ml-auto shrink-0"
                    aria-label={addLabel}
                    onClick={() => setParams({ action: showRecurring ? 'add-recorrente' : 'add' })}
                >
                    <Plus aria-hidden />
                    <span className="hidden sm:inline">{addLabel}</span>
                </button>
            </div>

            {showRecurring ? <VendasRecorrentes /> : <VendasList />}
        </div>
    );
}
